import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "災害のたびに一から説明が必要なボランティア教育の非効率を、水害現場をリアルに疑似体験できるVRコンテンツで解決。ゲーミフィケーションで学習意欲を保ちながら教育効果を両立し、動画教材もセットで制作。公共・公益分野向けVRコンテンツ開発の事例です。"

const ogpImg = "https://aitria.co.jp/images/img/cases/volunteerex/ogp_volunteer-ex.png"

export const volunteerExPageMeta: PageMeta = {
  title: "水害ボランティア研修をVRで体験学習に変革｜日本財団ボランティアセンターの開発事例 | Aitria（アイトリア）",
  description,
  keyword: "メタバース VR AR MR NFT Web3",
  image: ogpImg,
  url: `${SITE_URL}/cases/volunteer-ex/`,
}

export const volunteerExSchema = buildCaseStudySchema({
  slug: "volunteer-ex",
  pageTitle: volunteerExPageMeta.title,
  description: volunteerExPageMeta.description,
  headline: "VRコンテンツの開発で災害に関する教育の効率化",
  alternativeHeadline: "公益財団法人日本財団ボランティアセンター",
  primaryImage: ogpImg,
  images: [ogpImg,"https://aitria.co.jp/images/img/cases/caseStudyTop/volunteer-ex.webp"],
  clientName: "公益財団法人日本財団ボランティアセンター",
  breadcrumbLabel: "VRコンテンツの開発で災害に関する教育の効率化",
})
